// Logs a GTM event to identify when app fails to load.
export const gtmError = () => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event': '_trackEvent',
    'eventCategory': 'Provider Dashboard',
    'eventAction': 'Error',
    'eventLabel': 'Error loading dash'
  });
}